module.exports = __webpack_public_path__ + "img/no-leaves-booked.7b848b91.png";